(function () {
  var richTextSelector = '[id^="shopify-section-"][id$="rich_text_GCQAaQ"]';
  var panelSelectors = [
    '[id^="shopify-section-"][id$="custom_liquid_zGgTa8"]',
    '[id^="shopify-section-"][id$="custom_liquid_74DJfd"]'
  ];

  function getControls() {
    var richText = document.querySelector(richTextSelector);
    var panels = panelSelectors.map(function (selector) {
      return document.querySelector(selector);
    });

    if (!richText || panels.some(function (panel) { return !panel; })) return null;

    var triggers = Array.prototype.slice.call(richText.querySelectorAll('a.button')).slice(0, panels.length);
    if (triggers.length !== panels.length) return null;

    return { triggers: triggers, panels: panels };
  }

  function showPanel(activeIndex) {
    var controls = getControls();
    if (!controls) return;

    controls.triggers.forEach(function (trigger, index) {
      var isActive = index === activeIndex;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-pressed', String(isActive));
    });

    controls.panels.forEach(function (panel, index) {
      panel.hidden = index !== activeIndex;
    });
  }

  function initialize() {
    var controls = getControls();
    if (!controls) return;

    controls.triggers.forEach(function (trigger, index) {
      trigger.classList.add('seguimiento-trigger');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-controls', controls.panels[index].id);
      trigger.setAttribute('aria-pressed', 'false');
    });

    controls.panels.forEach(function (panel) {
      panel.classList.add('seguimiento-panel');
      panel.hidden = true;
    });
  }

  if (!window.seguimientoTabsBound) {
    window.seguimientoTabsBound = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(richTextSelector + ' a.button');
      if (!trigger) return;

      var controls = getControls();
      if (!controls) return;

      var index = controls.triggers.indexOf(trigger);
      if (index === -1) return;

      event.preventDefault();
      showPanel(index);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== ' ') return;

      var trigger = event.target.closest(richTextSelector + ' a.button');
      if (!trigger) return;

      event.preventDefault();
      trigger.click();
    });

    document.addEventListener('shopify:section:load', initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
